import { Info, Warning, CheckCircle, XCircle } from "@phosphor-icons/react";
import { Callout } from "@radix-ui/themes";

interface CalloutBlockProps {
  variant: "info" | "warning" | "success" | "error";
  text: string;
}

// Canvas semantic variants → Radix color scales. success (malachite) → grass
// and warning (puntt-gold) → amber per the Ask Puntt Radix-adoption direction.
// Radix Callout's soft variant carries the colored surface without the custom
// left-border accent the old hand-rolled callout used.
const VARIANT_CONFIG: Record<
  CalloutBlockProps["variant"],
  { color: "blue" | "amber" | "grass" | "red"; icon: React.ReactNode }
> = {
  info: { color: "blue", icon: <Info size={16} weight="fill" /> },
  warning: { color: "amber", icon: <Warning size={16} weight="fill" /> },
  success: { color: "grass", icon: <CheckCircle size={16} weight="fill" /> },
  error: { color: "red", icon: <XCircle size={16} weight="fill" /> },
};

export function CalloutBlock({ variant, text }: CalloutBlockProps) {
  const config = VARIANT_CONFIG[variant] ?? VARIANT_CONFIG.info;

  return (
    <Callout.Root
      color={config.color}
      variant="soft"
      size="1"
      data-testid={`callout-block-${variant}`}
    >
      <Callout.Icon>{config.icon}</Callout.Icon>
      <Callout.Text data-testid="callout-block-text">{text}</Callout.Text>
    </Callout.Root>
  );
}
